export const TERMS_AND_CONDITIONS_LINK = 'https://www.termsfeed.com/live/e4eeee24-3df9-4e2e-8740-92584fe4ebe2';
export const PRIVACY_POLICY_LINK = 'https://www.termsfeed.com/live/e1b260ad-b6c2-41cb-b554-e2d5285e0734';